(() => {
  if (window.CITIVELOSJournalFilter) return;
  window.CITIVELOSJournalFilter = true;

  const cache = new Map();

  const getSection = () => document.querySelector('[data-journal-section]');

  const sectionUrl = (href, sectionId) => {
    const url = new URL(href, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  };

  const loadMarkup = async (href, sectionId) => {
    const key = sectionUrl(href, sectionId);
    if (!cache.has(key)) {
      cache.set(key, fetch(key, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then((response) => {
        if (!response.ok) throw new Error('Journal filter request failed');
        return response.text();
      }));
    }
    return cache.get(key);
  };

  const replaceJournal = async (href, pushState = true) => {
    const current = getSection();
    if (!current) return;

    const sectionId = current.dataset.sectionId;
    current.classList.add('is-loading');
    current.setAttribute('aria-busy', 'true');

    try {
      const markup = await loadMarkup(href, sectionId);
      const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
      const next = documentFragment.querySelector('[data-journal-section]');
      if (!next) throw new Error('Journal section missing');

      current.replaceWith(next);
      if (pushState) history.pushState({ journal: true }, '', href);

      const active = next.querySelector('[data-journal-filter].is-active');
      if (active) active.setAttribute('aria-current', 'page');
      prefetchLinks(next);
    } catch (error) {
      window.location.assign(href);
    }
  };

  const prefetchLinks = (root = document) => {
    root.querySelectorAll('[data-journal-filter]').forEach((link) => {
      if (link.dataset.prefetchReady) return;
      link.dataset.prefetchReady = 'true';
      link.addEventListener('pointerenter', () => {
        const section = getSection();
        if (section) loadMarkup(link.href, section.dataset.sectionId).catch(() => {});
      }, { once: true });
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-journal-filter]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    replaceJournal(link.href, true);
  });

  window.addEventListener('popstate', () => replaceJournal(window.location.href, false));
  prefetchLinks();
})();
